import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import AnswerModeration from './AnswerModeration.jsx';
import CountdownScreen from '../CountdownScreen.jsx';
import DebateModeration from './DebateModeration.jsx';
import VoteModeration from './VoteModeration.jsx';
export default class OpenQuestionHandler extends Component {
    constructor(props) {
        super(props);
    }
    

    render(){
        let viewComponent = "";
        let viewName = this.props.information.view.split('.').slice(-1)[0];

        switch(viewName){
            //openQuestion.answer
            case("answer"):
                viewComponent = (
                    <AnswerModeration
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.countdown
            case("countdown"):
                viewComponent = (
                    <CountdownScreen
                    information={this.props.information}
                    sendSocketMessage={this.props.sendSocketMessage}
                    exitGame={this.props.exitGame}
                />
                );
                break;
            //openQuestion.debate
            case("debate"):
                viewComponent = (
                    <DebateModeration
                    information={this.props.information}
                    sendSocketMessage={this.props.sendSocketMessage}
                    exitGame={this.props.exitGame}
                />
                );
                break;
            case("vote"):
                viewComponent = (
                    <VoteModeration
                    information={this.props.information}
                    sendSocketMessage={this.props.sendSocketMessage}
                    exitGame={this.props.exitGame}
                />
                );
                
        }
            return (
                <div>
                    {viewComponent}
                </div>
            );
    }
}